$(document).on ('ajax:error', '#expense_form', (event) => {
  data = event.detail[0], http_status = event.detail[1], xhr = event.detail[2]
  form = $('#expense_form')
  alert = '<div id="expense-error" class="alert alert-danger alert-dismissable" role="alert">'
  alert = alert + '<button class="btn-close" type="button" data-bs-dismiss="alert" aria-label="Close"></button>'
  $.each(data.errors, (idx, msg) => {
    alert = alert + `<strong>・${msg}</strong><br>`
  })
  alert = alert + '</div>'

  if ($('#expense-error')[0]) {
    $('#expense-error').remove()
    form.prepend(alert)
  } else {
    form.prepend(alert)
  }
})
